import { render, staticRenderFns } from "./payment-iq-withdraw.vue?vue&type=template&id=3733cbd7&scoped=true"
import script from "./payment-iq-withdraw.vue?vue&type=script&lang=js"
export * from "./payment-iq-withdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733cbd7",
  null
  
)

export default component.exports